import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Input, Table, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { createSearchParams, Link, Outlet, useSearchParams } from 'react-router-dom';

import useAPIQuery from '../../../api/useAPIQuery';
import Filter from '../../../components/Filter';
import SearchParam from '../../../components/SearchParam';
import useTypedNavigate from '../../../hooks/useTypedNavigate';
import useTypedParams from '../../../hooks/useTypedParams';
import { withRouteChange } from '../../../services/APM';
import { StaffUserCollection } from '../../../types';

const StaffUsers = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();

  const users = useAPIQuery(
    [
      '/staff-users/',
      {
        params: {
          is_active: true,
          page: parseInt(searchParams.get('page') || '1', 10),
          page_size: parseInt(searchParams.get('pageSize') || '10', 10),
          ...(searchParams.get('search') ? { search: searchParams.get('search') as string } : {}),
        },
      },
    ],
    {
      keepPreviousData: true,
    }
  );

  return (
    <>
      <Helmet>
        <title>Usuários Staff | Área do CS | Recrutamento e Seleção</title>
      </Helmet>
      <Outlet />
      <Filter>
        <Col flex="auto">
          <SearchParam name="search" onSetSearchParams={{ page: '1' }}>
            <Input.Search allowClear style={{ marginBottom: 10 }} />
          </SearchParam>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() =>
              navigate({
                pathname: '/:tenant/settings/cs-staff/staff-users/create/',
                params: { tenant },
              })
            }
          >
            Novo usuário
          </Button>
        </Col>
      </Filter>

      <Table
        rowKey="id"
        dataSource={users.data?.results}
        loading={users.isFetching}
        pagination={{
          showTotal: (total) => {
            return `Total: ${total} usuários`;
          },
          total: users.data?.count,
          onChange: (page, pageSize) => {
            searchParams.set('page', page.toString());
            searchParams.set('pageSize', pageSize.toString());
            setSearchParams(searchParams);
          },
          current: parseInt(searchParams.get('page') || '1', 10),
          pageSize: parseInt(searchParams.get('pageSize') || '10', 10),
        }}
      >
        <Table.Column
          title="Usuário"
          render={(record: StaffUserCollection) => (
            <Link
              to={{
                pathname: `${record.id}/change`,
                search: createSearchParams(searchParams).toString(),
              }}
            >
              {record.username}
            </Link>
          )}
        />
        <Table.Column
          title="Nome"
          render={(record: StaffUserCollection) => (
            <Typography.Text>{record.full_name}</Typography.Text>
          )}
        />
      </Table>
    </>
  );
};

export default withRouteChange()(StaffUsers);
